// Reuse the gateway's active Material Dashboard card styling.
import { STATUS_TONES } from "./channelUtils";

export const surfaceSx = ({ palette, borders, boxShadows, components, functions: { rgba } }) => ({
  backgroundColor: components.MuiCard.styleOverrides.root.backgroundColor,
  border: `1px solid ${rgba(palette.text.main, 0.12)}`,
  borderRadius: borders.borderRadius.xl,
  boxShadow: boxShadows.md,
});

export const nestedSurfaceSx = ({ palette, borders, functions: { rgba } }) => ({
  backgroundColor: rgba(palette.text.main, 0.035),
  border: `1px solid ${rgba(palette.text.main, 0.1)}`,
  borderRadius: borders.borderRadius.md,
});

export const toneMain = (palette, tone) => palette[tone]?.main || palette.text.main;

export const toneChipSx = (tone) => ({ palette, functions: { rgba } }) => ({
  height: 22,
  borderRadius: "6px",
  fontWeight: 700,
  fontSize: "0.7rem",
  letterSpacing: 0.2,
  color: toneMain(palette, tone),
  backgroundColor: rgba(toneMain(palette, tone), 0.16),
  border: `1px solid ${rgba(toneMain(palette, tone), 0.32)}`,
  "& .MuiChip-label": { px: 1 },
  "& .MuiChip-icon": { color: "inherit", fontSize: "0.75rem", ml: 0.75 },
});

export const statusTone = (channel) => STATUS_TONES[channel?.status?.level] || "secondary";

// Fill bars stay "info" while normal so the page is not a wall of green.
export const fillToneFor = (channel) => (channel?.status?.level === "ok" ? "info" : statusTone(channel));

// Palette keys used for compare series in the history chart (selected channel is always "info").
export const SERIES_TONES = ["info", "primary", "warning", "success", "error"];
